const collectionToArray = <T extends Element>(xs: HTMLCollectionOf<T>) => {
  const output: T[] = [];
  for (let i = 0; i < xs.length; i++) {
    output.push(xs[i]);
  }
  return output;
};

export default collectionToArray;